import Decimal from 'decimal.js';

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}
export const formatNumber = (value, digits = 0) => {
  if (value && !isNaN(value)) {
    const processedValue = typeof value === 'string' ? value?.replace(',', '') : value;
    const decimalValue = new Decimal(processedValue);
    const rounded = decimalValue.toFixed(digits);
    const parts = String(rounded).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (digits === 0) {
      return parts[0] !== 'NaN' ? parts[0] : '-';
    }
    return parts[1] && Number(parts[1]) === 0 ? parts[0] : parts.join('.');
  }
  return value;
};
